import React, { useState } from 'react';
import { Radio } from 'modules/shared-ui-advanced/vendors/semantic-ui';

import { Redirect } from 'react-router';

import { routes } from 'config';

import { PageTitle } from 'modules/shared-ui/components/typography';
import { UniverseTypeValues } from 'modules/shared/models/customer';

import { ChooseListProps } from './choose-list-type';

import styles from './choose-list-component.module.css';

export const ChooseList: React.FC<ChooseListProps> = () => {
    const [url, setUrl] = useState('');

    if (url) return <Redirect to={url} />;

    return (
        <React.Fragment>
            <div className={styles.chooseList}>
                <div className={styles.title}>
                    <PageTitle title="JE N’AI PAS ENCORE DE LISTE" uppercase centered />
                    <p>Je choisis l’évènement pour lequel j’ouvre ma liste et je crée mon compte</p>
                </div>
                <div className={styles.radioList}>
                    <Radio
                        label={`Liste de ${UniverseTypeValues.UNIVERS_MARIAGE.valStr}`}
                        name="listUniverse"
                        value={`${routes.creerListe.voyageMariage}${UniverseTypeValues.UNIVERS_MARIAGE.valStr}`}
                        onChange={(e, { value }) => setUrl(value ? value.toString() : '')}
                    />
                    {/* <Radio
                        label={`Liste de ${UniverseTypeValues.UNIVERS_VOYAGE.valStr}`}
                        name="listUniverse"
                        value={`${routes.creerListe.voyageMariage}${UniverseTypeValues.UNIVERS_VOYAGE.valStr}`}
                        onChange={(e, { value }) => setUrl(value ? value.toString() : '')}
                    /> */}
                    <Radio
                        label={`Liste de ${UniverseTypeValues.UNIVERS_NAISSANCE.valStr}`}
                        name="listUniverse"
                        value={`${routes.creerListe.cadeauxNaissance}${UniverseTypeValues.UNIVERS_NAISSANCE.valStr}`}
                        onChange={(e, { value }) => setUrl(value ? value.toString() : '')}
                    />
                    <Radio
                        label={`Liste de ${UniverseTypeValues.UNIVERS_CADEAUX.valStr}`}
                        name="listUniverse"
                        value={`${routes.creerListe.cadeauxNaissance}${UniverseTypeValues.UNIVERS_CADEAUX.valStr}`}
                        onChange={(e, { value }) => setUrl(value ? value.toString() : '')}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};
